export default __webpack_public_path__ + "static/media/Vincent02.1c620a9b.jpg";